import React, { useEffect } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { XIcon } from 'lucide-react';
type ModalProps = {
  open: boolean;
  onClose: () => void;
  title: string;
  paragraphs: string[];
};
export function Modal({
  open,
  onClose,
  title,
  paragraphs
}: ModalProps) {
  useEffect(() => {
    if (!open) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', onKey);
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', onKey);
      document.body.style.overflow = '';
    };
  }, [open, onClose]);
  return <AnimatePresence data-id="element-170" data-mp="4z8tpilg6xs4">
      {open && <div className="fixed inset-0 z-50 flex items-end justify-center px-4 py-6 sm:items-center" role="dialog" aria-modal="true" aria-label={title} data-id="element-171" data-mp="4ziaqgoilulo">
          <motion.button type="button" aria-label="Cerrar" onClick={onClose} className="absolute inset-0 h-full w-full cursor-default bg-ink/35 backdrop-blur-sm" initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.3
      }} data-id="element-172" data-mp="9wigeqhgcvc9" />
          <motion.div className="relative w-full max-w-xl rounded-[1.75rem] border border-sand bg-ivory p-8 shadow-[0_30px_80px_-40px_rgba(58,51,46,0.5)] sm:p-11" initial={{
        opacity: 0,
        y: 30,
        scale: 0.98
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 20,
        scale: 0.98
      }} transition={{
        duration: 0.45,
        ease: [0.16, 1, 0.3, 1]
      }} data-id="element-173" data-mp="2mbex8n2b7zra">
            <button type="button" onClick={onClose} aria-label="Cerrar ventana" className="absolute right-5 top-5 rounded-full border border-sand p-2 text-warmgray transition-colors hover:border-gold hover:text-gold" data-id="element-174" data-mp="358q00hn5hbbh">
              <XIcon className="h-4 w-4" data-id="element-175" data-mp="1naisgalqr4d" />
            </button>

            <span className="font-sans text-[0.6rem] uppercase tracking-luxe text-gold" data-id="element-176" data-mp="3syk9qqc6ajri">
              Punto de Acción
            </span>
            <h2 className="mt-3 font-display text-3xl font-light text-ink" data-id="element-177" data-mp="1w1ob3ypd9g2i">{title}</h2>
            <div className="mt-6 space-y-4 font-sans text-[0.95rem] font-light leading-relaxed text-warmgray" data-id="element-178" data-mp="1w3r1wkycfd8a">
              {paragraphs.map(p => <p key={p} data-id="element-179" data-mp="1mbbg1cjxe4i4">{p}</p>)}
            </div>
          </motion.div>
        </div>}
    </AnimatePresence>;
}